// ui
import { Button, Typography, Modal, Box } from "@mui/material";
import { useWindowSize } from "../lib/useWindowSize";

interface RequestLoadingModalProps {
  onModal: boolean;
}

export function RequestLoadingModal(props: RequestLoadingModalProps) {
  const { onModal } = props;
  const { windowWidth, windowHeight } = useWindowSize();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
          <Box className="shippori-antique-regular">
            システムが更新されています。
            <br />
            「更新ボタン」もしくは「F5」を押して画面を更新してください。
          </Box>
        </Typography>
      </Box>
    </Modal>
  );
}
